import React from "react";
import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";
import { COMPANY } from "@/data/site";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <P>
        This Privacy Policy explains how {COMPANY.name} ("we", "us", "our") collects, uses and protects personal data
        when you use this website or contact us. We are committed to protecting your privacy in line with the UK GDPR
        and the Data Protection Act 2018.
      </P>

      <H2>1. Who we are (Data Controller)</H2>
      <P>
        The data controller is {COMPANY.name}, registered address: {COMPANY.registeredAddress}. For any privacy-related
        queries, contact us at <a className="underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
      </P>

      <H2>2. What data we collect</H2>
      <UL
        items={[
          "Contact details you provide via our contact form: your name, email address, phone number (if provided) and the content of your message.",
          "Technical data collected automatically, such as your IP address, browser type and user agent, for security and to keep the site working.",
          "Cookie data, only where you have given consent for non-essential cookies (see our Cookie Policy).",
        ]}
      />

      <H2>3. How and why we use your data (lawful bases)</H2>
      <UL
        items={[
          "To respond to your enquiries and provide quotes — our legitimate interests in responding to people who contact us about our services.",
          "For non-essential cookies and any optional analytics — your consent, which you may withdraw at any time.",
          "To comply with legal or regulatory obligations where applicable — legal obligation.",
        ]}
      />

      <H2>4. How long we keep your data</H2>
      <P>
        We keep enquiry details for a defined period of typically 12–24 months so we can respond and follow up, unless
        a contract or ongoing relationship means we need to keep them longer. After this we securely delete or anonymise
        the data.
      </P>

      <H2>5. Who we share your data with (Processors)</H2>
      <P>We do not sell your data. We may share it with trusted service providers who process it on our behalf, including:</P>
      <UL
        items={[
          "Our website hosting provider, which stores the site and any submitted enquiries.",
          "Our email service provider, used to send and receive enquiry notifications.",
          "Spam-protection services, if used, to keep the contact form secure.",
        ]}
      />

      <H2>6. International transfers</H2>
      <P>
        We aim to keep personal data within the UK or European Economic Area. Where any provider processes data outside
        the UK/EEA, we ensure appropriate safeguards (such as UK adequacy regulations or standard contractual clauses)
        are in place.
      </P>

      <H2>7. Your rights</H2>
      <P>Under UK data protection law you have the right to:</P>
      <UL
        items={[
          "Access the personal data we hold about you.",
          "Request correction (rectification) of inaccurate data.",
          "Request erasure of your data.",
          "Request restriction of processing.",
          "Object to processing based on legitimate interests.",
          "Data portability, where applicable.",
          "Withdraw consent at any time where processing is based on consent.",
          "Complain to the Information Commissioner's Office (ICO) at ico.org.uk.",
        ]}
      />

      <H2>8. Security</H2>
      <P>
        We take reasonable technical and organisational measures to protect your data against unauthorised access, loss
        or misuse. No online transmission is completely secure, but we work to keep your data safe.
      </P>

      <H2>9. Children</H2>
      <P>Our website and services are not directed at children and we do not knowingly collect data relating to children.</P>

      <H2>10. Changes to this policy</H2>
      <P>
        We may update this policy from time to time. The version and date at the top of this page reflect the latest
        revision.
      </P>
    </LegalLayout>
  );
}
